/**
 * Cloudflare Turnstile site key (public). The matching secret stays in
 * `verify-turnstile.ts` and is never imported by client components.
 *
 * Production must set NEXT_PUBLIC_TURNSTILE_SITE_KEY. In development, when that
 * variable is unset, Cloudflare's documented always-pass test key is used so
 * the form can be exercised locally. That test key always succeeds and must
 * not be relied on outside local development.
 */
const TURNSTILE_TEST_SITE_KEY = '1x00000000000000000000AA';

export function getTurnstileSiteKey(): string {
  const configured = process.env.NEXT_PUBLIC_TURNSTILE_SITE_KEY?.trim() ?? '';
  if (configured) return configured;
  if (process.env.NODE_ENV !== 'production') return TURNSTILE_TEST_SITE_KEY;
  return '';
}
